import { render, staticRenderFns } from "./PermissionsAccountants.vue?vue&type=template&id=e2a3d12a&"
import script from "./PermissionsAccountants.vue?vue&type=script&lang=js&"
export * from "./PermissionsAccountants.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports